import { HttpClient, RegistrationApi } from '../../../api'
import { Context } from '../../../common'
import { SelfRegisterOpts, SelfRegistrationService } from './selfRegistrationService'

export class RemoteSelfRegistrationService implements SelfRegistrationService {
  private api: RegistrationApi

  constructor(httpClient: HttpClient) {
    this.api = new RegistrationApi(httpClient, undefined, '')
  }

  async checkRegistrationCode(ctx: Context, email: string, authCode: string): Promise<boolean> {
    const result = await this.api.registrationCheckCode(ctx, { email, authCode })
    return result.body.valid
  }

  async selfRegister(ctx: Context, user: SelfRegisterOpts, authCode: string): Promise<void> {
    await this.api.registrationSelfRegister(ctx, { userOpts: user, authCode })
  }
}
